import { AxiosResponse } from "../axios";
import { ApiBody } from "../@types/apiTypes";
import { ApiPagination } from "./apiPagination";

export function apiBodyParser(response: AxiosResponse): ApiBody {
  if (!hasPagination(response)) {
    return {
      data: response.data,
    };
  }
  return {
    data: response.data.results,
    pagination: new ApiPagination(response),
  };
}

function hasPagination(response: AxiosResponse): boolean {
  return (
    Object.keys(response.data).length === 2 &&
    "meta" in response.data &&
    "results" in response.data
  );
}
